import React from "react";
import { ITourismEventResult } from "../../lib/models/ITourismEvents";

export default function TourismEventResult(props) {
  const { data } = props;

  if (props.number === 0 && props.page === 1) {
    return (
      <div className="col-12 col-sm-6 col-md-12">
        <a href={data.Url} target="_self">
          <div className={"insight-teaser image-left"}>
            <div
              className="image"
              style={{
                backgroundImage: `url(${data.TeaserImageUrl}?width=575)`
              }}
              role="img"
              aria-label={data.TeaserImageAltText}
            ></div>
            <div className="text">
              <p className="teaser-type tourism-event">{data.DateRange}</p>
              <h4>{data.Name}</h4>
              <p className="teaser-cta-text">{data.TeaserCTAText}</p>
            </div>
          </div>
        </a>
      </div>
    );
  }
  return (
    <div className="col-12 col-sm-6 col-md-4">
      <a href={data.Url} target="_self">
        <div className={"insight-teaser image-top"}>
          <div
            className="image"
            style={{
              backgroundImage: `url(${data.TeaserImageUrl}?width=575)`
            }}
            role="img"
            aria-label={data.TeaserImageAltText}
          ></div>
          <div className="text">
            <p className="teaser-type tourism-event">{data.DateRange}</p>
            <h4>{data.Name}</h4>
          </div>
        </div>
      </a>
    </div>
  );
}
